import { statuses } from './statuses';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { Group } from '../types/entities/Group';
import { Activity } from '../types/entities/Activity';
import { NumberField } from '../components/Table/fields/NumberField';
import { DateField } from '../components/Table/fields/DateField';
import { TimeField } from '../components/Table/fields/TimeField';
import { TextField } from '../components/Table/fields/TextField';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPDateField } from '../components/Table/fields/SPDateField';

export const groupActivityReservationTable = (
  forGroupId?: Group['id'],
  forActivityId?: Activity['id']
): SchemaWithClient<any> => {
  return {
    name: 'Activity Reservation',
    treeData: true,
    pluralName: 'Activity',
    columns: {
      name: {
        name: 'Activity Name',
        required: false,
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
        readOnly: true,
        hide: true,
        tab_name: 'general',
      },
      status: {
        name: 'Status',
        fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
          statuses.activityStatus
        ),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(
          statuses.activityStatus
        ),
        switchboard: true,
        url: statuses.activityStatus.client.getAllPath,
        tempSchema: statuses.activityStatus,
      },
      date: {
        name: 'Date',
        fieldRenderer: DateField,
        slidePaneFieldRenderer: SPDateField,
        fieldType: 'date',
        width: 'medium',
        tab_name: 'general',
      },
      meeting_time: {
        name: 'Meeting',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
        width: 'small',
        tab_name: 'general',
      },
      pickup_time: {
        name: 'Pickup',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
        width: 'small',
        tab_name: 'general',
      },
      start_time: {
        name: 'Start',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
        width: 'small',
        tab_name: 'general',
      },
      group_size: {
        name: 'Size',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
        width: 'medium',
        tab_name: 'general',
      },
      guides: {
        name: 'Guides',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      guide_phones: {
        name: 'Guide Phones',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      guide_wages: {
        name: 'Guide Wages',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      artists: {
        name: 'Artists',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      driver: {
        name: 'Driver',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      meeting_place: {
        name: 'Pickup Place',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      venue: {
        name: 'Venue',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      service_provider_names: {
        name: 'Service Providers',
        fieldRenderer: TextField,
        slidePaneFieldRenderer: SPTextField,
        fieldType: 'text',
      },
      notes: {
        name: 'Notes',
        fieldRenderer: RichTextField,
        slidePaneFieldRenderer: SPRichTextField,
        fieldType: 'textarea',
        tab_name: 'general',
      },
      id: {
        name: 'ID',
        required: true,
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
        readOnly: true,
      },
    },
    client: new Client(
      '/activity-reservations',
      forGroupId !== undefined
        ? `/groups/${forGroupId}/activity-reservations`
        : undefined
    ),
    viewTable: 'group_activity_reservations',
  };
};
